import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../../../../../../components/userAvatar/UserAvatar";
import CheckBox from "../../../../../../components/inputs/checkBox/CheckBox";
import PrimeBadge from "../../../../../../components/primeBadge/PrimeBadge";
import TextWrapper from "../../../../../../components/textWrapper/TextWrapper";
import styles from "./oneWinner.module.css";

const OneWinner = ({ winner, handleTogglePrize }) => {
  const userImage = winner?.userInfo?.userImage?.path;

  const navigate = useNavigate();
  const { rolePermissions } = useSelector((state) => state.user);
  const canMarkDelivered = rolePermissions.includes("mark-prizes-delivered");
  const canOpenChat = rolePermissions.includes("view-user-chats");

  const handleChange = () => {
    handleTogglePrize(winner.userId, winner.tableId, winner.hasReceivedPrize);
  };

  const handleNavigateToChat = () => {
    navigate("/dashboard/customer-support/show-users-chats", {
      state: { userName: winner?.userInfo?._id },
    });
  };

  return (
    <div
      className={
        winner?.hasReceivedPrize
          ? `${styles.container} ${styles.recievedPrize}`
          : styles.container
      }
    >
      <div className={styles.userInfoWrapper}>
        <div className={styles.userInfo}>
          <div className={styles.userNameRow}>
            <TextWrapper textStyle={"textMid"}>
              {winner?.userInfo?.name}
            </TextWrapper>
            <PrimeBadge isPrime={winner?.userInfo?.isPrime} primeTier={winner?.userInfo?.primeTier} size="small" />
          </div>
          {canOpenChat && (
            <div className={styles.chatWrapper} onClick={handleNavigateToChat}>
              <TextWrapper textStyle={"textSmall"}>
                التحدث مع المستخدم
              </TextWrapper>
            </div>
          )}
        </div>
        <div className={styles.userImage}>
          <UserAvatar src={userImage} alt="user" />
        </div>
      </div>

      <CheckBox
        checked={winner?.hasReceivedPrize}
        onChange={handleChange}
        disabled={!canMarkDelivered}
      />
    </div>
  );
};

export default OneWinner;
